import {
  bindHover,
  bindMenu,
  usePopupState,
} from 'material-ui-popup-state/hooks';

import { KeyboardArrowDown } from '@mui/icons-material';

import {
  ButtonDropdown,
  DropdownItem,
  DropdownItemLabel,
  DropdownItemLink,
  DropdownMenu,
} from '../Navbar.styles';

const RelatoriesMenu = () => {
  const relatoriesMenuState = usePopupState({ variant: 'popover' });

  const gerencialItems = [
    {
      label: 'Utilização do Produto',
      link: `${process.env.REACT_APP_GESTAO_BASE_URL}/main/reports/product-usage`,
    },
    {
      label: 'Evolução dos Processamentos',
      link: `${process.env.REACT_APP_GESTAO_BASE_URL}/main/reports/processing-evolution`,
    },
    {
      label: 'Utilização das Licenças',
      link: `${process.env.REACT_APP_GESTAO_BASE_URL}/main/reports/license-usage`,
    },
  ];

  const operacionalItems = [
    {
      label: 'Relatório Geral das Operações',
      link: `${process.env.REACT_APP_GESTAO_BASE_URL}/main/reports/relatorio-gestao`,
    },
  ];

  return (
    <>
      <ButtonDropdown
        {...bindHover(relatoriesMenuState)}
        endIcon={<KeyboardArrowDown />}
      >
        Relatórios
      </ButtonDropdown>
      <DropdownMenu {...bindMenu(relatoriesMenuState)}>
        <DropdownItemLabel>Gerencial</DropdownItemLabel>
        {gerencialItems.map((item) => (
          <DropdownItemLink href={item.link} key={item.label}>
            <DropdownItem>{item.label}</DropdownItem>
          </DropdownItemLink>
        ))}

        <DropdownItemLabel>Operacional</DropdownItemLabel>
        {operacionalItems.map((item) => (
          <DropdownItemLink href={item.link} key={item.label}>
            <DropdownItem>{item.label}</DropdownItem>
          </DropdownItemLink>
        ))}
      </DropdownMenu>
    </>
  );
};

export default RelatoriesMenu;
